import getHistory from "../Components/Common/GlobalHistory";
import Router from "../Resources/Router.json";
import Screen from "../Resources/Screen.json";

export const CreateRequestOption = (method, params, header) => {
    var headers = header ? header : {
        'Content-Type': 'application/json',
        'Cache-Control': 'no-cache'
    };

    return {
        method: method,
        headers: headers,
        credentials: 'include',
        body: params ? JSON.stringify(params) : null
    };
}

export const RedirectWithComponent = (url, params) => {
    const history = getHistory();
    url = url ? url : '/';

    if ((url.length > 1 && history.location.pathname.includes(url)) || url === history.location.pathname)
        return;

    if (url === Router.Error) {
        params = {
            enable: true
        }
    }

    if (history) {
        history.push({
            pathname: url ? url : '/',
            state: params ?? {}
        });
    }
};

export const RedirectUrl = (url) => {
    // ClearAuditLog();
    // localStorage.clear();
    if (!url) return;

    if (!url.startsWith('http')) {
        // Format URL
        if (url.startsWith('/')) {
            url = `${window.location.origin}/${process.env.REACT_APP_SUB_FOLDER}/${url}`;
        }
        else {
            url = `${window.location.origin}/${process.env.REACT_APP_SUB_FOLDER}${url}`;
        }

        if (url.endsWith('/')) {
            url = url.substring(0, url.length - 1);
        }
    }

    window.location.href = url;
}

export const customMessage = (result) => {
    if (result) {
        var message = result.UserMessage + "\n";
        if (result.DetailMessage == null) {
            let messageResult = message + Screen.TransferMessage.TransferFail;
            return messageResult;
        }
        else if (Array.isArray(result.DetailMessage)) {
            for (let i = 0; i < result.DetailMessage.length; i++) {
                const element = result.DetailMessage[i];
                if (element) {
                    message += `\t${element}\n`;
                }
            }
            return message + Screen.TransferMessage.TransferFail;
        }
        else {
            let messageResult = message + "\t" + result.DetailMessage + "\n" + Screen.TransferMessage.TransferFail;
            return messageResult;
        }
    }
    return null;
}
export const getCurrentDate = (date) => {
    let value = parseInt(date);
    return parseInt(date) < 10 ? "0" + value : value;
}
